function show(a) {
    document.querySelector(".text-box").value = a;
}
$(document).ready(function () {
    new WOW().init(),
        $(window).enllax(),
        $(".menu_button").click(function () {
            $("html").hasClass("show_menu") ? $("html").removeClass("show_menu") : $("html").addClass("show_menu");
        }),
        $(".menu_overlay").click(function () {
            $("html").hasClass("show_menu") && $("html").removeClass("show_menu");
        }),
        $(".menu_close").click(function () {
            $("html").hasClass("show_menu") && $("html").removeClass("show_menu");
        }),
        $(".filt-btn").click(function () {
            $("html").hasClass("show_filter") ? $("html").removeClass("show_filter") : $("html").addClass("show_filter");
        }),
        $(".filter_overlay").click(function () {
            $("html").hasClass("show_filter") && $("html").removeClass("show_filter");
        }),
        $(".filter_close").click(function () {
            $("html").hasClass("show_filter") && $("html").removeClass("show_filter");
        }),
        $("#categaories_carousel").owlCarousel({
            loop: !1,
            margin: 35,
            dots: !0,
            autoplay: !1,
            nav: !1,
            autoplayTimeout: 2e3,
            autoplayHoverPause: !0,
            responsiveClass: !0,
            responsive: { 0: { items: 1 }, 375: { items: 1 }, 575: { items: 2 }, 768: { items: 2 }, 992: { items: 3 }, 1099: { items: 4 } },
        }),
        $("#team_carousel").owlCarousel({
            loop: !1,
            margin: 35,
            dots: !0,
            autoplay: !1,
            nav: !1,
            autoplayTimeout: 2e3,
            autoplayHoverPause: !0,
            responsiveClass: !0,
            responsive: { 0: { items: 1 }, 375: { items: 1 }, 575: { items: 2 }, 768: { items: 2 }, 992: { items: 3 }, 1099: { items: 4 } },
        }),
        $("#Certification_carousel").owlCarousel({
            loop: !1,
            margin: 35,
            dots: !0,
            autoplay: !1,
            nav: !1,
            autoplayTimeout: 2e3,
            autoplayHoverPause: !0,
            responsiveClass: !0,
            responsive: { 0: { items: 1 }, 375: { items: 1 }, 575: { items: 2 }, 768: { items: 2 }, 992: { items: 3 }, 1099: { items: 4 }, 1099: { items: 5 } },
        }),
        $("#featuredproduct_carousel").owlCarousel({
            autoplay: !0,
            lazyLoad: !0,
            loop: !0,
            margin: 10,
            nav: !1,
            dots: !0,
            animateOut: "fadeOut",
            animateIn: "fadeIn",
            responsiveClass: !0,
            autoHeight: !0,
            autoplayTimeout: 7e3,
            smartSpeed: 900,
            navText: ['<div class="RL_arrow"> <i class="RlLftArw"></i> </div>', '<div class="RL_arrow"> <i class="RlRhtArw"></i> </div>'],
            responsive: { 0: { items: 1, margin: 0 }, 600: { items: 3 }, 1e3: { items: 4, loop: !1, margin: 30 } },
        }),
        
      $('#banner_carousel').owlCarousel({
          loop:true,
          margin:10,
          
          autoplay:false,
          autoplayTimeout:5000,
          responsive:{
              0:{
                  items:1
              },
              600:{
                  items:1
              },
              1000:{
                  items:1
              }
          }
      }),
      $('#category-carousel').owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:4
            }
        }
      }),
       $('#customer_review_slider').owlCarousel({
        loop:true,
        margin:10,
        nav:false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
      }),
        $("#product_carousel").owlCarousel({
            loop: !1,
            margin: 35,
            dots: !0,
            autoplay: !1,
            nav: !1,
            autoplayTimeout: 2e3,
            autoplayHoverPause: !0,
            responsiveClass: !0,
            responsive: { 0: { items: 1 }, 375: { items: 1 }, 575: { items: 1 }, 768: { items: 1 }, 992: { items: 1 }, 1099: { items: 1 } },
        }),
        $("#customer_review").owlCarousel({
            loop: !1,
            margin: 35,
            dots: !0,
            autoplay: !1,
            nav: !1,
            autoplayTimeout: 2e3,
            autoplayHoverPause: !0,
            responsiveClass: !0,
            responsive: { 0: { items: 1 }, 375: { items: 1 }, 600: { items: 1 }, 768: { items: 1 }, 992: { items: 1 }, 1200: { items: 1 } },
        }),
        $("ul.tabs li").click(function () {
            var a = $(this).attr("data-tab");
            $("ul.tabs li").removeClass("current"), $(".tab-content").removeClass("current"), $(this).addClass("current"), $("#" + a).addClass("current");
        }),
        $("#adress1").click(function () {
            $("#deleverHereBtn1").removeClass("d-none"), $("#deleverHereBtn2").addClass("d-none");
        }),
        $("#adress2").click(function () {
            $("#deleverHereBtn2").removeClass("d-none"), $("#deleverHereBtn1").addClass("d-none");
        }),
        $("#cartadreschandbtn").click(function () {
            "Change" == $("#cartadreschandbtn").html() ? ($(".cart_paymentOption").addClass("d-none"), $("#cartadreschandbtn").html("Edit")) : ($(".cart_paymentOption").removeClass("d-none"), $("#cartadreschandbtn").html("Change")),
                $(".filter__Col").toggleClass("active"),
                $("#cartadressshow").toggle(),
                $("#cartadressedit").toggle(),
                $("body").addClass("FilternoScroll");
        }),
        $(".deliverhr-btn").click(function () {
            $(".cart_paymentOption").removeClass("d-none"), $("#cartadressedit").hide(), $("#cartadressshow").show(), $("#cartadreschandbtn").html("Change");
        });
}),
    $("#aboutteam").owlCarousel({
        autoplay: !0,
        lazyLoad: !0,
        loop: !0,
        margin: 10,
        nav: !0,
        dots: !1,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        responsiveClass: !0,
        autoHeight: !0,
        autoplayTimeout: 7e3,
        smartSpeed: 900,
        navText: ['<div class="RL_arrow"> <i class="RlLftArw"></i> </div>', '<div class="RL_arrow"> <i class="RlRhtArw"></i> </div>'],
        responsive: { 0: { items: 1, margin: 0 }, 600: { items: 3 }, 1e3: { items: 4, loop: !1, margin: 50 } },
    }),
    $("#whatwedo").owlCarousel({
        autoplay: !0,
        lazyLoad: !0,
        loop: !0,
        margin: 10,
        nav: !0,
        dots: !1,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        responsiveClass: !0,
        autoHeight: !0,
        autoplayTimeout: 7e3,
        smartSpeed: 900,
        navText: ['<div class="RL_arrow"> <i class="RlLftArw"></i> </div>', '<div class="RL_arrow"> <i class="RlRhtArw"></i> </div>'],
        responsive: { 0: { items: 1, margin: 0 }, 600: { items: 3 }, 1e3: { items: 5, loop: !1, margin: 50 } },
    }),
    $("#productDtlslid01").owlCarousel({
        autoplay: !0,
        lazyLoad: !0,
        loop: !0,
        margin: 10,
        nav: !1,
        dots: !0,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        responsiveClass: !0,
        autoHeight: !0,
        autoplayTimeout: 7e3,
        smartSpeed: 900,
        navText: ['<div class="RL_arrow"> <i class="RlLftArw"></i> </div>', '<div class="RL_arrow"> <i class="RlRhtArw"></i> </div>'],
        responsive: { 0: { items: 1, margin: 0 }, 600: { items: 1 }, 1e3: { items: 1, loop: !1, margin: 0 } },
    }),
    $("#productDtlslid02").owlCarousel({
        autoplay: !0,
        lazyLoad: !0,
        loop: !0,
        margin: 10,
        nav: !1,
        dots: !0,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        responsiveClass: !0,
        autoHeight: !0,
        autoplayTimeout: 7e3,
        smartSpeed: 900,
        navText: ['<div class="RL_arrow"> <i class="RlLftArw"></i> </div>', '<div class="RL_arrow"> <i class="RlRhtArw"></i> </div>'],
        responsive: { 0: { items: 1, margin: 0 }, 600: { items: 3 }, 1e3: { items: 4, loop: !1, margin: 30 } },
    }),
    $(document).on("click", ".qty-plus", function () {
        $(this)
            .prev()
            .val(+$(this).prev().val() + 1);
    }),
    $(document).on("click", ".qty-minus", function () {
        $(this).next().val() > 0 &&
            $(this)
                .next()
                .val(+$(this).next().val() - 1);
    });
let dropdown = document.querySelector(".cartDelverAdrss");
(dropdown.onclick = function () {
    dropdown.classList.toggle("active");
}),
    $(document).ready(function () {});
var prev = document.getElementById("prev"),
    next = document.getElementById("next"),
    trak = document.getElementById("progress"),
    step = document.getElementById("step");
next.addEventListener("click", function () {
    var a = trak.className.split("-").pop();
    a > 6 ? (a = 0) : a++, (step.innerHTML = a), (trak.className = "progress-" + a);
}),
    prev.addEventListener("click", function () {
        var a = trak.className.split("-").pop();
        a < 1 ? (a = 7) : a--, (step.innerHTML = a), (trak.className = "progress-" + a);
    });
